var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"i-body"},[_c('el-aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.aside),expression:"aside"}],staticClass:"i-side",attrs:{"width":"270px"}},[_c('tree')],1),_c('el-main',{staticClass:"i-main"},[_c('div',{staticClass:"map-shadow elevation-1"}),_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vue/cli-service/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a80fb62","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/@vue/cli-service/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/layout-tree.vue
// module id = null
// module chunks = 